import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("circle", {
  fill: "currentColor",
  cx: 10,
  cy: 10,
  r: 9
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M2 10c0-1.846.635-3.543 1.688-4.897l11.209 11.209A7.954 7.954 0 0 1 10 18c-4.411 0-8-3.589-8-8m14.312 4.897L5.103 3.688A7.954 7.954 0 0 1 10 2c4.411 0 8 3.589 8 8a7.952 7.952 0 0 1-1.688 4.897M0 10c0 5.514 4.486 10 10 10s10-4.486 10-10S15.514 0 10 0 0 4.486 0 10"
});

var SvgCircleDisabledMajorTwotone = function SvgCircleDisabledMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref, _ref2);
};

export { SvgCircleDisabledMajorTwotone as S };
